import 'css-chunksrc/client/common/filterMenu/resources/resource/styles.scss';export default {
  "resource": "_resource_1ppp0_1",
  "icon": "_icon_1ppp0_11",
  "name": "_name_1ppp0_18",
  "profession": "_profession_1ppp0_25"
};